import { INotification, Notification } from '../Notification'
import { NotificationTypeEnum } from '../NotificationTypeEnum'
import { IRestaurantLimitExceededEmailData } from './IRestaurantLimitExceededEmailData'
import { NotificationClassificationEnum, User } from '../..'

import htmlTemplate from './RestaurantLimitExceededEmailTemplate'

export interface IRestaurantLimitExceededEmail extends INotification {
  data: IRestaurantLimitExceededEmailData
}

export class RestaurantLimitExceededEmail extends Notification implements IRestaurantLimitExceededEmail {
  constructor(public to: User, public data: IRestaurantLimitExceededEmailData) {
    super(to, NotificationTypeEnum.RESTAURANT_LIMIT_EXCEEDED, NotificationClassificationEnum.EMAIL)
  }

  public get subject() {
    return 'Restaurant Limit Exceeded'
  }

  public get body() {
    return htmlTemplate
  }
}
